import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_th = _resolveComponent("b-th")!
  const _component_b_tr = _resolveComponent("b-tr")!
  const _component_b_thead = _resolveComponent("b-thead")!
  const _component_b_td = _resolveComponent("b-td")!
  const _component_b_tbody = _resolveComponent("b-tbody")!
  const _component_b_table_simple = _resolveComponent("b-table-simple")!
  const _component_dev = _resolveComponent("dev")!

  return (_openBlock(), _createBlock(_component_dev, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Загрузка..."))
        : (_openBlock(), _createBlock(_component_b_table_simple, {
            key: 1,
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_thead, { "head-variant": "light" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_tr, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("#")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("Учетный месяц")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("Учетный год")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Сумма начисление")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("БИН ДО")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("LMS ID")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Документ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_tbody, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childFactPaymentResponseList, (data, index) => {
                    return (_openBlock(), _createBlock(_component_b_tr, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(index + 1), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.accountingMonth), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.accountingYear), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.payedAmount), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.bin), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.lmsId), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.handleDownload(data.reportUUID, data.signedPdfName)),
                              class: "active-link"
                            }, _toDisplayString(data.signedPdfName), 9, _hoisted_2)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}